import { render, staticRenderFns } from "./AbsencesPage.vue?vue&type=template&id=10ed1276&scoped=true&lang=pug&"
import script from "./AbsencesPage.vue?vue&type=script&lang=ts&"
export * from "./AbsencesPage.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesPage.vue?vue&type=style&index=0&id=10ed1276&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed1276",
  null
  
)

export default component.exports